<template>
    <div>
        <!-- <div>env: {{ myEnv }}</div> -->

        <h3>Места встройки приложения</h3>
        <b-form inline>
            <b-form-group
                label="Адрес обработчика:"
                label-for="input-app-url"
            >
                <b-form-input
                    id="input-app-url"
                    v-model="appUrl"
                    placeholder="укажите адреc обработчика"
                    type="url"
                    required
                ></b-form-input>
                <b-button variant="primary" @click="setAppUrl">Встроить</b-button>
            </b-form-group>
        </b-form>
        <b-button inline variant="primary" @click="getPlacements">Получить места встройки</b-button>
        <b-button inline variant="danger" @click="deleteAllPlacements">Удалить все места встройки</b-button>
        <btable :items="placement" />

        <h3>Дополнительные свойства Хранилища </h3>
        <p>свойства будут добавлены в указанное Хранилище</p>
        <b-form inline>
            <b-input
                placeholder="Укажите хранилище"
                v-model="propertiesForEntity"
                type="text"
                required
                class="mb-2"
            ></b-input>
            <b-button class="mb-2" variant="success" @click="addProperties()">Добавить новые свойства</b-button>
            <b-button class="mb-2" @click="getProperty ( propertiesForEntity )">Смотреть дополнительные свойства</b-button>

        </b-form>
        <btable :items="property" />

        <!-- <h3>Секции Хранилища store</h3>
        <b-button @click="getEntitySections( entityName )">Добавление секции</b-button>
        <b-button @click="addSection()">Добавление секции</b-button>
        <btable :items="section" /> -->

        <h3>Хранилища</h3>
        <b-form inline>
            <b-input
                v-model="newEntity"
                type="text"
                required
                class="mb-2"
            ></b-input>
            <b-button class="mb-2" @click="addEntity()">Добавить хранилище</b-button>
        </b-form>

        <btable
            :items="entity"
            tableType="entity"
        />
        <b-button
                variant="info"
                @click="bitrixDelete"
                class="mb-1"
                disabled
            >Удалить хранилища Битрикса</b-button>

    </div>

</template>

<script>
import btable from './b-table.vue'
import { newPropertiesStore } from '../store/models'

export default {
  components: {
    btable
  },
    data(){
        return {
            appUrl:'',
            entity: [],
            placement: [],
            property: [],
            entityName: '',
            section: [],
            accrual: [],
            newEntity: '',
            propertiesForEntity: 'accrual',
            myEnv: process.env.NODE_ENV,
        }
    },
    async mounted()
    {
        this.$store.dispatch( 'getAllEntity', { root: true } )
        .then (result => {
            // console.dir (result)
            result.map ( item => {
                this.entity.push (
                {
                    'name': item.ENTITY,
                    'value': item.ID,
                    'item': item
                })

            })
        })

        // Получаем данные хранилища
        this.getProperty ( this.propertiesForEntity )

        this.getPlacements ()
    },
    methods:{
        getEntitySections ( entityName ) {
            this.section = []
            if ( !entity ) return console.log('Не указано хранилище');
            this.$store.dispatch( 'entitySectionGet', entityName, { root: true } )
            .then (result => {
                // console.dir (result)
                result.map ( item => {
                    this.section.push (
                    {
                        'name': item.ID,
                        'value': item.NAME,
                        'item': item
                    })

                })
            })
        },
        getPlacements () {
            this.placement = []
            this.$store.dispatch ( 'getPlacements', {root: true} )
            .then ( result => {
                if ( result ) {
                    result.map ( item => {
                        this.placement.push (
                        {
                            'name': item.placement,
                            'value': item.handler,
                            'item': item
                        })
                    })
                } else {
                    console.log( 'Ошибка получения данных о встройке приложения!' );
                }
            })
        },
        deleteAllPlacements () {
            this.$store.dispatch ( 'getPlacements', { root: true} )
            .then ( existPlacements => {
                // console.dir(existPlacements);
                if ( existPlacements ) {
                    existPlacements.forEach ( item => {
                        BX24.callMethod( 'placement.unbind', { PLACEMENT: item.placement })
                    })
                }
            })
            .then ( () => this.getPlacements ())
        },
        getProperty ( entityName ) {
            this.property = []
            this.$store.dispatch( 'getProperty', entityName, { root: true } )
            .then (result => {
                result.map ( item => {
                    this.property.push (
                    {
                        'name': item.NAME,
                        'value': item.PROPERTY,
                        'item': item
                    })

                })
            })
        },
        async addEntity () {
            if ( this.newEntity ) {
                if ( await this.$store.dispatch ('entityAdd', this.newEntity, { root: true }) == 200 ) {
                    console.log( 'Хранилище ' + this.newEntity + ' успешно создано!' );
                } else {
                    console.log( 'Ошибка создания хранилища ' + this.newEntity );
                }
            } else {
                console.log('Не указано название Хранилища');
            }
            // accrual
        },
        async addProperties () {
            if ( !this.propertiesForEntity ) {
                // TODO По хорошему надо проверять наличие хранилища
                return console.log( 'Не указано хранилище куда добавлять свойства');
            }
            newPropertiesStore.forEach ( item => {
                let newProperty = {
                    ENTITY: this.propertiesForEntity,
                    PROPERTY: item.PROPERTY,
                    NAME: item.NAME,
                    TYPE: item.TYPE
                }
                this.$store.dispatch ( 'propertyAdd', newProperty, { root: true } )
                .then( answer =>
                {
                    if ( answer == 200 ) console.log('Свойство добавлено успешно');
                    if ( answer == 400 ) console.log('Ошибка добавленя свойства');
                })
            })
        },
        async addSection() {
            let newSection = {
                ENTITY: 'store',
                NAME: 'test'
            }
            console.dir ( await this.$store.dispatch ( 'entitySectionAdd', newSection ) )
        },
        // удаление хранилищ Битрикс24
        bitrixDelete: ( () => {
            this.$store.dispatch ('deleteEntity', 'store', { root: true })
            this.$store.dispatch ('deleteEntity', 'settings', { root: true })
        }),
        async setAppUrl () {

            this.$store.dispatch ( 'setAllPlacements', this.appUrl, {root: true} )

            // console.log( await this.fetchSetAppUrl ( this.appUrl ) );
            // await BX24.callMethod( 'placement.bind', { PLACEMENT: 'CRM_DEAL_DETAIL_TAB', HANDLER: this.appUrl, TITLE: tittleApp } )
            // await BX24.callMethod( 'placement.bind', { PLACEMENT: 'CRM_CONTACT_DETAIL_TAB', HANDLER: this.appUrl, TITLE: tittleApp } )
            // await BX24.callMethod( 'placement.bind', { PLACEMENT: 'CRM_COMPANY_DETAIL_TAB', HANDLER: this.appUrl, TITLE: tittleApp } )
            // await BX24.callMethod( 'placement.bind', { PLACEMENT: 'TASK_VIEW_TAB', HANDLER: this.appUrl, TITLE: tittleApp } )
            this.getPlacements ()
        },
        // fetchSetAppUrl ( appUrl ) {
        //     // console.log( payload );
        //     return new Promise ((resolve, reject) =>
        //     {
        //         // TODO Рефакторинг - Некрасивый код
        //         if ( appUrl ) {
        //             BX24.appOption.set ( 'appUrl', appUrl, ( result ) => {
        //                 resolve ( result );
        //             })
        //         } else {
        //             reject ( 'Ошибка выполнения запроса' );
        //         }
        //     })
        // },
    }
}
</script>

<style>

</style>
